var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.chart && _vm.chart.series)?_c('apexchart',{attrs:{"options":_vm.chart.options,"series":_vm.chart.series,"height":"90%","width":"100%"}}):_c('div',{staticClass:"no-data-message"},[_vm._v(" Sin información para mostrar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }